import { useCallback, useMemo } from 'react';
import * as http from '../request/http';
import PortalIdParser from 'PortalIdParser';
import { useAsyncFetcher } from '../asyncData/useAsyncFetcher';
import { PORTAL_BRAND_KITS_ENDPOINT } from '../constants/brandKits';
export const useFetchPortalBrandKits = (deferred = false) => {
  const fetcher = useCallback(requestArgs => http.get(PORTAL_BRAND_KITS_ENDPOINT, {
    requestArgs
  }), []);
  const resultFormatter = useCallback(result => result.toJS(), []);
  const requestArgs = useMemo(() => ({
    portalId: PortalIdParser.get()
  }), []);
  const brandKitsData = useAsyncFetcher({
    fetcher,
    requestArgs,
    resultFormatter,
    deferred
  });
  return brandKitsData;
};